// extracted by mini-css-extract-plugin
export default {"primary-button":"Button_primary-button__qxXuP","disabled-button":"Button_disabled-button__-oCCd"};